<template>
  <div class="item">
    <router-link class="item__link" :to="{name: PATHS_NAME.USER.SETTINGS}" @click="toClose"> 
      <UserProfile class="item__icon" /> Профиль
    </router-link> 
  </div>
</template>

<script setup>
  import { useStore } from "vuex";
  import { computed } from "vue";
  import { PATHS_NAME } from "@shared/routers/consts/pathsName";
  import { useScreenSize } from '@/Groups/Audioplayer/private/imports/screenSize';
  //------------------------------------------
  import UserProfile from "@svg/UserProfile.vue";
  //------------------------------------------
  const store = useStore();
  //------------------------------------------
  const { isLessThanSM } = useScreenSize()
  //------------------------------------------
  const emit = defineEmits(['close-menu']);
  //------------------------------------------
  //Есть ли у пользователя пон?
  const withPonButton = computed(() => store.state.UserSystem.user.has_pon_subscription);
  //Есть ли у пользователя подписка на телеграм?
  const withTelegramSubscription = computed(() => store.state.UserSystem.user.has_telegram_subscription);
  //------------------------------------------
  //Закрыть дропдаун
  const toClose = () => emit('close');
  
</script>

<style lang="scss" scoped>
  @import 'styles.scss';
</style>
